var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLocation(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    fill: "white",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    style: {
      lineHeight: "normal",
      textIndent: 0,
      textAlign: "start",
      textDecorationLine: "none",
      textDecorationStyle: "solid",
      textDecorationColor: "#000",
      textTransform: "none",
      blockProgression: "tb",
      whiteSpace: "normal",
      isolation: "auto",
      mixBlendMode: "normal",
      solidColor: "#000",
      solidOpacity: 1
    },
    d: "M7.994-.002c-2.48 0-4.5 2.02-4.5 4.5a.5.5 0 0 0 .024.158c.042 1.579.726 2.96 1.53 4.24.832 1.323 1.795 2.563 2.413 3.829a.5.5 0 0 0 .894.01c.65-1.265 1.662-2.507 2.536-3.829.873-1.322 1.619-2.75 1.619-4.4a.5.5 0 0 0-.033-.186C12.38 1.925 10.413-.002 7.994-.002zm0 1c1.94 0 3.5 1.561 3.5 3.5a.5.5 0 0 0 .01.107c-.03 1.308-.634 2.52-1.447 3.75-.688 1.041-1.466 2.116-2.137 3.233-.637-1.112-1.371-2.185-2.024-3.223C5.103 7.102 4.51 5.86 4.51 4.505a.5.5 0 0 0-.008-.087A3.488 3.488 0 0 1 7.994.998zm0 2.002c-.822 0-1.5.678-1.5 1.5S7.172 6 7.994 6c.823 0 1.5-.678 1.5-1.5S8.817 3 7.994 3zm0 1c.282 0 .5.218.5.5 0 .282-.218.5-.5.5a.493.493 0 0 1-.5-.5c0-.282.218-.5.5-.5zm4.09 5.227a.5.5 0 0 0-.18.966c.997.404 1.638.933 1.914 1.42.277.487.27.908-.091 1.426-.725 1.036-3.036 1.954-5.674 1.965-2.639.01-4.982-.883-5.748-1.922-.383-.52-.402-.943-.145-1.428.258-.484.875-1.018 1.856-1.43a.5.5 0 1 0-.387-.921c-1.12.47-1.937 1.102-2.352 1.883-.415.78-.343 1.722.223 2.49 1.132 1.534 3.711 2.34 6.559 2.328 2.847-.012 5.402-.837 6.488-2.39.543-.777.58-1.723.14-2.495-.438-.772-1.273-1.394-2.408-1.853a.5.5 0 0 0-.195-.04z",
    color: "#000",
    enableBackground: "accumulate",
    fontFamily: "sans-serif",
    fontWeight: 400,
    overflow: "visible"
  }));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocation);
export default __webpack_public_path__ + "static/media/location.c27c30699aa82ce7c31a0e40ef1219d9.svg";
export { ForwardRef as ReactComponent };